import(/* webpackMode: "eager" */ "/home/ubuntu/download_staging/6a7028108295d500146792d6_1785907295797_1235de11/vatulend/src/app/investors/page.tsx");
